// extracted by mini-css-extract-plugin
module.exports = {"Image":"Gallery_Image__z6Wg0","Caption":"Gallery_Caption__ZvB_2"};